import { Link } from "react-router";
import { useMemo } from "react";

import { games } from "../../data/metadata/games";

import { useGetMetadata } from "../../data/metadata/getMetadata/useGetMetadata";

export function Home() {
  const { data } = useGetMetadata();

  const gamesWithData = useMemo(() => {
    if (!data) return [];
    return games.filter((game) => data.categories[game.id]?.length);
  }, [data]);

  return (
    <main>
      <div className="bg-canvas-95">
        <div className="mx-auto flex flex-col items-center gap-12 py-24">
          <span className="font-style-subheading-1">Welcome to</span>
          <h1 className="font-style-mobile-h1 md:font-style-desktop-h1">BLAST MEDIAKIT</h1>
          <span className="font-style-b1-body-copy">Your one-stop shop for all BLAST assets!</span>
          <a
            className="button-secondary"
            href="https://blast.tv/fankit/content-policy"
            target="_blank"
            rel="noreferrer"
          >
            Media Kit Policy
          </a>
        </div>
      </div>
      <div className="mx-auto box-content flex max-w-8xl flex-col gap-12 px-4 py-12 md:px-6">
        <h3 className="font-style-desktop-h3">Ecosystems</h3>
        <div
          className="grid gap-5"
          style={{
            gridTemplateColumns: `repeat(auto-fill, minmax(345px, 1fr)`,
          }}
        >
          {gamesWithData.map((game) => (
            <Link to={`/assets/${game.id}`} key={game.id} className="rounded-large bg-canvas-95 p-6 text-center">
              <img
                src={game.image}
                alt={game.name}
                className="mb-6 block aspect-square w-full rounded-large object-cover object-center"
              />
              <h4 className="font-style-desktop-h4">{game.name}</h4>
            </Link>
          ))}
        </div>
      </div>
    </main>
  );
}
